module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goBackHome":"Go back to home page","pageNotFound":"The page or information sought was not found"},"fr":{"goBackHome":"Retour à l\u0027accueil","pageNotFound":"La page ou l\u0027information recherchée n\u0027a pas été trouvée"}}')
  delete Component.options._Ctor
}
